import React, { ComponentProps, ReactNode, useId } from 'react';
import { Tooltip as AnyUITooltip, TooltipProps as AnyUITooltipProps } from '@anyui/core';
import { cn } from '@anytag/shared-utils';
import { Portal } from '../Portal';

type TooltipRootProps = ComponentProps<typeof AnyUITooltip>;
export interface TooltipProps
  extends Omit<TooltipRootProps, 'label' | 'sx' | 'children'>,
    Omit<AnyUITooltipProps, 'children'> {
  help?: ReactNode;
  children: React.ReactElement<{ id?: string }>;
  className?: string;
  disabled?: boolean;
  withinPortal?: boolean;
}

export const Tooltip = ({
  id,
  children,
  help,
  disabled,
  className,
  withinPortal,
  isOpen,
  ...restProps
}: TooltipProps) => {
  const tooltipId = useId();
  const anchorId = id ?? tooltipId;

  const tooltipElement = (
    <AnyUITooltip anchorSelect={`#${anchorId}`} isOpen={isOpen} className={cn('z-100')} {...restProps}>
      {(help && !disabled ? help : null) as AnyUITooltipProps['children']}
    </AnyUITooltip>
  );

  return (
    <>
      {React.cloneElement(children, { id: anchorId })}

      {withinPortal ? <Portal portalId="portal-root">{tooltipElement}</Portal> : tooltipElement}
    </>
  );
};
